import script from "./View.vue?vue&type=script&setup=true&lang=js"
export * from "./View.vue?vue&type=script&setup=true&lang=js"

import "./View.vue?vue&type=style&index=0&id=7400f325&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7400f325"]])

export default __exports__